export const memoTitle = {
  'IPC': 'Interest and Penalty',
  'TPRatio': 'Transfer Pricing',
  'ThinCap': 'Thin Capitalization',
  'NOL': 'Net Operating Loss',
};
export const memoToolId = {
  'IPC': 'itrce-interest-and-penalty',
  'TPRatio': 'itrce-transfer-pricing',
  'ThinCap': 'itrce-thin-capitalization',
  'NOL': 'itrce-net-operating-loss',
};

export const showDataCells = [
  'HeaderCell',
  'DataHeaderCell',
  'ReadOnlyPercentageCell',
  'SubHeaderCell',
  'ReadOnlyFormulaCell',
  'ReadOnlyDateCell',
  'NormalCell'
];



